<template>
    <div id="recruiter_index_candidates" class="flex_content">

        <div id="context_bar">
            <TopbarSearchPosition @positionSearchUpdated="updateSearchQuery" />
            <!-- <TopbarAddPosition /> -->
        </div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1">{{ $t('modules.positions.index.title') }}</h1>
                <div class="has-text-centered">
                    <router-link to="/positions/new" >
                        <button class="button  is-info is-rounded is-outlined">{{ $t('modules.positions.index.newPositionButton') }}</button>
                    </router-link>
                </div>
            </template>
        </titlePage>

        <div id="index_positions_content" class="hero flex">
            <div class="hero-body flex_content">
                <div class="container has-text-centered ">

                    <TablePositions :searchQuery="query" />

                    <nav class="pagination table-pagination is-centered is-medium">
                        <paginate
                            :page-count="totaPages"
                            :click-handler="OnPageChange"
                            :prev-text="'<'"
                            :next-text="'>'"
                            :page-link-class="'pagination-link'"
                            :active-class="'is-current'"
                            :prev-link-class="'pagination-link'"
                            :next-link-class="'pagination-link'"
                            :disabled-class="'is-disabled'"
                            :container-class="'pagination-list'">
                        </paginate>
                    </nav>

                </div>
            </div>
        </div>

    </div>

</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import TopbarSearchPosition from "../components/topbar/topbarSearchPosition"
import TablePositions from "../components/index/tablePositions"

import posed from 'vue-pose';


export default {
    name: 'PositionIndex',
    components: {
        TitlePage,
        TopbarSearchPosition,
        TablePositions
    },
    beforeCreate() {
        this.$store.dispatch('PositionStore/indexPositions', {page: 1})
    },
    data(){
        return {
            query: ""
        }
    },
    computed: {
        currentPage(){
            return this.$store.state.PositionStore.currentPage
        },
        totaPages(){
            return this.$store.state.PositionStore.totalPages
        },
        itemPerPage(){
            return this.$store.state.PositionStore.itemPerPage
        }
    },
    methods: {
        updateSearchQuery(query){
            this.query = query
        },
        OnPageChange(currentpage){
            this.$store.dispatch('PositionStore/indexPositions', {page: currentpage})
        }
    }
}
</script>

<style lang="scss">
#index_positions_content{
    background: $white;
}
</style>

